module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03-m-jp.101bc2319995af61af08a2f0d0c307f8.png";